import React from 'react'

const Globe18pxSvg = (props) => {
    return (
        <svg 
        {...props}
        xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <g clipPath="url(#clip0_227_212)">
                <path d="M16.5 9.50879C16.5 13.6509 13.1421 17.0088 9 17.0088M16.5 9.50879C16.5 5.36665 13.1421 2.00879 9 2.00879M16.5 9.50879H1.5M9 17.0088C4.85786 17.0088 1.5 13.6509 1.5 9.50879M9 17.0088C10.876 14.955 11.9421 12.2898 12 9.50879C11.9421 6.72781 10.876 4.06255 9 2.00879M9 17.0088C7.12404 14.955 6.05794 12.2898 6 9.50879C6.05794 6.72781 7.12404 4.06255 9 2.00879M1.5 9.50879C1.5 5.36665 4.85786 2.00879 9 2.00879" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_227_212">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.508789)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Globe18pxSvg